'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var codesandboxURL = exports.codesandboxURL = 'https://codesandbox.io/api/v1/sandboxes/define?query=module=/example.js';
var codesandboxURLJSON = exports.codesandboxURLJSON = 'https://codesandbox.io/api/v1/sandboxes/define?json=1';
var getSandboxUrl = exports.getSandboxUrl = function getSandboxUrl(id) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 's';
  var fileName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'example';
  return 'https://codesandbox.io/' + type + '/' + id + '?module=/' + fileName;
};